import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { MapPin, ArrowRight } from "lucide-react";
import { NEAREST_CITIES, getPanneBaseSlug, buildComboSlug } from "@/data/panneVilleData";

/**
 * Section "Cette réparation dans les villes voisines"
 * Affichée en bas de chaque PannePage pour maillage interne vers les
 * 216 pages panne×ville (Phase C).
 */
export const PanneNearbyCities = ({ panne }) => {
  const base = getPanneBaseSlug(panne);
  const short = panne.titleH1.split(" à Niort")[0].split(" - ")[0];

  return (
    <section className="section-padding bg-slate-50" data-testid="panne-nearby-cities">
      <div className="container-custom max-w-5xl">
        <div className="text-center mb-8">
          <Badge className="bg-red-100 text-red-700 px-4 py-2 mb-4 hover:bg-red-100">
            <MapPin className="w-4 h-4 mr-1" />
            Aussi disponible
          </Badge>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2">
            {short} dans les villes voisines
          </h2>
          <p className="text-slate-600 text-sm">
            Pages dédiées avec route d&apos;accès et FAQ locale pour chaque ville.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3">
          {NEAREST_CITIES.map((city) => {
            const slug = buildComboSlug(base, city.slug);
            return (
              <Link
                key={city.slug}
                to={`/${slug}`}
                className="flex items-center justify-between bg-white hover:bg-red-50 rounded-lg p-4 border border-slate-100 hover:border-red-200 transition-all group"
                data-testid={`panne-nearby-${city.slug}`}
              >
                <div>
                  <p className="font-semibold text-slate-900 group-hover:text-red-600">{short} {city.name}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{city.distanceKm} km • {city.timeMinutes} min</p>
                </div>
                <ArrowRight className="h-4 w-4 text-slate-400 group-hover:text-red-600 group-hover:translate-x-1 transition-all" />
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-6">
          <Link to="/reparations-locales" className="text-red-600 text-sm font-medium hover:underline">
            Voir toutes les réparations locales →
          </Link>
        </div>
      </div>
    </section>
  );
};
